// one time subscription js start

(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container:has([data-one-time-option-radio])';
  // const BUNDLE_SELLING_PLAN_ID = '714600022401';

  let originalBtn = null; // the theme's real button, with all its original listeners
  let customBtn = null;   // a clone, stripped of listeners, used only in bundle mode

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive() {
    const radio = document.querySelector(
      BUNDLE_GROUP_SELECTOR + ' [role="radio"]'
    );

    return radio && radio.getAttribute('aria-checked') === 'true';
  }

  // ---------------------------------------------------------------------
  // Inject the flavour UI's visual styling ONCE as a <style> tag (not as
  // inline styles on each element). Keeps the DOM clean/classes-only while
  // still giving the exact look: full-width, stacked, rounded option
  // buttons with a subtle border, and a highlighted state when selected.
  // ---------------------------------------------------------------------
  function injectStyles() {
    if (document.getElementById('flavor-ui-styles')) return;

    const style = document.createElement('style');
    style.id = 'flavor-ui-styles';
    style.textContent = `
      .flavor-select-container { margin-top: 10px; }
      .flavor-select-title { margin: 6px 0; }
      .flavor-bottle-label {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 12px;
      }
      .flavor-options {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .flavor-option {
        width: 100%;
        padding: 14px 18px;
        border-radius: 12px;
        border: 1px solid #ddd;
        background: #fff;
        cursor: pointer;
        text-align: left;
        font-size: 15px;
        color: #333;
      }
      .flavor-option:hover {
        border-color: #bbb;
      }
      .flavor-option.active {
        border-color: #ff7f91;
        background: #fff5f6;
        color: #000;
      }
      .flavor-error-msg {
        color: #c0392b;
        font-size: 13px;
        margin: 4px 0;
      }
    `;
    document.head.appendChild(style);
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.display = 'none'; // functional: toggled by updateFlavorVisibility()

    const title = document.createElement('p');
    title.className = 'flavor-select-title';
    title.textContent = 'Choose your flavour:';
    wrapper.appendChild(title);

    for (let i = 1; i <= 1; i++) {
      const label = document.createElement('div');
      label.className = 'flavor-bottle-label';

      // const labelText = document.createElement('span');
      // labelText.textContent = 'Bottle ' + i;
      // label.appendChild(labelText);

      const flavorWrapper = document.createElement('div');

      flavorWrapper.className = 'flavor-options';
      flavorWrapper.dataset.bottleIndex = i;

      FLAVORS.forEach(flavor => {

        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'flavor-option';

        button.textContent = flavor.name;

        button.dataset.flavorName = flavor.name;

        button.addEventListener('click', function () {

          // remove previous active
          flavorWrapper.querySelectorAll('.flavor-option')
            .forEach(btn => btn.classList.remove('active'));

          // active current
          this.classList.add('active');

          // save selected value
          flavorWrapper.dataset.selectedFlavor = flavor.name;

        });

        flavorWrapper.appendChild(button);

      });


      label.appendChild(flavorWrapper);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.display = 'none'; // functional: shown/hidden dynamically in addBundleToCart
    wrapper.appendChild(errorMsg);

    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    // protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // Inject a short "1 bottle · 16 daily servings" line directly under the
  // "One-time purchase" label/price row. Plain text only — no radio
  // button involved. Reuses the theme's own description class so it
  // matches typography/spacing automatically.
  //
  // Uses a unique data-attribute (data-custom-serving-info) to detect its
  // own element on repeat MutationObserver runs, same pattern as
  // injectOneTimeSubtitle, so it never duplicates or gets confused with a
  // theme-rendered element that looks similar.
  // ---------------------------------------------------------------------
  function injectServingInfo() {
    const radioContainer = document.querySelector('[data-one-time-option-radio]');
    if (!radioContainer) return;

    const row = radioContainer.closest('.seal-row');
    if (!row) return;

    const labelContainer = row.querySelector('.sls-label-container');
    if (!labelContainer) return;

    const firstLine = labelContainer.querySelector('.sls-selling-plan-group-first-line');
    if (!firstLine) return;

    const servingText = '16 daily servings · 1 bottle';

    let servingInfo = labelContainer.querySelector('[data-custom-serving-info]');

    if (servingInfo) {
      // Already inserted — refill if it somehow ended up empty
      if (servingInfo.textContent.trim() === '') {
        servingInfo.textContent = servingText;
      }
      forceVisible(servingInfo);
      return;
    }

    servingInfo = document.createElement('div');
    // Reuse the theme's existing description class for identical styling,
    // plus a unique data-attribute so we can reliably find/detect it later.
    servingInfo.className = 'sls-selling-plan-description-content serving-info-line';
    servingInfo.setAttribute('data-custom-serving-info', 'true');
    servingInfo.textContent = servingText;

    forceVisible(servingInfo);

    // Insert right after the label/price row. Since injectOneTimeSubtitle
    // also inserts "afterend" of firstLine, call order in checkAndInit
    // determines final stacking (see checkAndInit below).
    firstLine.insertAdjacentElement('afterend', servingInfo);
  }

  // ---------------------------------------------------------------------
  // The theme only shows `.sls-selling-plan-description-content` elements
  // when the parent `.sls-option-container` has the `.sls-active` class
  // (i.e. when that plan is the currently selected/checked one). Our
  // injected lines should stay visible REGARDLESS of checked/unchecked
  // state, so we force the relevant CSS properties with !important via
  // inline style, which wins over the theme's stylesheet rule (unless the
  // theme rule is also !important, which is rare).
  // ---------------------------------------------------------------------
  function forceVisible(el) {
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
  }

  // ---------------------------------------------------------------------
  // Inject a subtitle under the "One-time purchase" heading so it
  // matches the description text shown under the subscription options
  // (e.g. "Deliver Every 16 days"). We reuse the theme's own
  // `.sls-selling-plan-description-content` class so typography, color
  // and spacing are automatically identical — no custom CSS needed.
  //
  // We identify our own injected element via a unique data-attribute
  // (not just the class name) so it never gets confused with a
  // similar-looking empty div the theme itself might render in the
  // same spot. If the element exists but its text is empty for any
  // reason, we refill it instead of skipping.
  // ---------------------------------------------------------------------
  function injectOneTimeSubtitle() {
    const radioContainer = document.querySelector('[data-one-time-option-radio]');
    if (!radioContainer) return;

    const row = radioContainer.closest('.seal-row');
    if (!row) return;

    const labelContainer = row.querySelector('.sls-label-container');
    if (!labelContainer) return;

    const firstLine = labelContainer.querySelector('.sls-selling-plan-group-first-line');
    if (!firstLine) return;

    let subtitle = labelContainer.querySelector('[data-custom-one-time-subtitle]');

    if (subtitle) {
      // Already inserted — if it somehow ended up empty, refill it
      if (subtitle.textContent.trim() === '') {
        subtitle.textContent = 'New to Healü? Start here and see visible results in as little as 4 weeks';
      }
      return;
    }

    subtitle = document.createElement('div');
    // Reuse the theme's existing description class for identical styling,
    // plus a unique data-attribute so we can reliably find/detect it later.
    subtitle.className = 'sls-selling-plan-description-content one-time-subtitle';
    subtitle.setAttribute('data-custom-one-time-subtitle', 'true');
    subtitle.textContent = 'New to Healü? Start here and see visible results in as little as 4 weeks';

    firstLine.insertAdjacentElement('afterend', subtitle);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorOptions = Array.from(
      document.querySelector(BUNDLE_GROUP_SELECTOR)
        .querySelectorAll('.flavor-options')
    );
    const errorMsg = document
      .querySelector(BUNDLE_GROUP_SELECTOR)
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorOptions.some(
      option => !option.dataset.selectedFlavor
    );

    if (flavorOptions.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';


    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorOptions
      .sort((a, b) =>
        parseInt(a.dataset.bottleIndex) -
        parseInt(b.dataset.bottleIndex)
      )
      .map(option => option.dataset.selectedFlavor);

    // const flavourText =
    //   "Selected Bottle:\n" +
    //   selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

const flavourText = selectedFlavorNames.join(", ");

    // let items;
    // items = [{
    //   id: currentProductId,
    //   quantity: 1,
    //   properties: {
    //     flavourText
    //   }
    // }];

let items;

items = [{
  id: currentProductId,
  quantity: 1,
  properties: {
     flavourText
  }
}];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          drawer.open();

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // ✅ RESET UI (THIS WAS MISSING)

        // reset dropdowns
        document
          .querySelector(BUNDLE_GROUP_SELECTOR)
          .querySelectorAll('.flavor-options')
          .forEach(option => {

            option.dataset.selectedFlavor = '';

            option.querySelectorAll('.flavor-option')
              .forEach(btn => btn.classList.remove('active'));

          });

        // hide error
        const errorMsg = document.querySelector('.flavor-error-msg');
        if (errorMsg) {
          errorMsg.style.display = 'none';
          errorMsg.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // Set up the clone once we find the real button
  // ---------------------------------------------------------------------
  function setupButtonSwap(form) {
    if (originalBtn) return; // already done
    const btn = form.querySelector('.add-to-cart');
    if (!btn) return;

    originalBtn = btn;
    customBtn = btn.cloneNode(true);
    customBtn.type = 'submit';
    customBtn.removeAttribute('onclick');
    customBtn.style.display = ''; // ensure it's never left hidden

    customBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      addBundleToCart(form, customBtn);
    });
  }

  // ---------------------------------------------------------------------
  // Swap the button in/out depending on which plan is selected.
  // Visually it's the SAME button (identical clone) — only its wiring differs.
  // Neither button is ever hidden; only one of the two is in the DOM at a time.
  // ---------------------------------------------------------------------
  function syncButtons(form) {
    if (!originalBtn || !customBtn) return;
    const active = isBundleActive();

    if (active) {
      if (originalBtn.isConnected) {
        originalBtn.parentNode.replaceChild(customBtn, originalBtn);
      }
    } else {
      if (customBtn.isConnected) {
        customBtn.parentNode.replaceChild(originalBtn, customBtn);
      }
    }
  }

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectStyles();
    injectFlavorUI(bundleContainer);

    // Call order matters here: insertAdjacentElement('afterend', ...) on
    // firstLine always places the newly-inserted element as the very next
    // sibling of firstLine, pushing whatever was already there further
    // down. We call injectOneTimeSubtitle() FIRST (so it lands right after
    // firstLine), then injectServingInfo() SECOND — its element ends up
    // between firstLine and the subtitle, giving final order:
    //   firstLine -> "1 bottle · 16 daily servings" -> "New to Healü..."
    injectOneTimeSubtitle();
    injectServingInfo();

    setupButtonSwap(form);
    syncButtons(form);
    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          syncButtons(form);
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);
})();


// one time subscription js end


// subscribe and save js start like:


(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group="0"]';
  const BUNDLE_SELLING_PLAN_ID = '2784755970';

  let originalBtn = null; // the theme's real button, with all its original listeners
  let customBtn = null;   // a clone, stripped of listeners, used only in bundle mode

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive(form) {
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

    if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

    const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
    if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

    return false;
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.marginTop = '10px';
    wrapper.style.display = 'none';

    const title = document.createElement('p');
    title.textContent = 'Choose your flavour:';
    title.style.margin = '6px 0';
    wrapper.appendChild(title);

    for (let i = 1; i <= 1; i++) {
      const label = document.createElement('div');
      label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

      // const labelText = document.createElement('span');
      // labelText.textContent = 'Bottle ' + i;
      // label.appendChild(labelText);

      const flavorWrapper = document.createElement('div');
      flavorWrapper.className = 'flavor-options';
      flavorWrapper.dataset.bottleIndex = i;
      flavorWrapper.style.cssText = `
  display:flex;
  gap:10px;
  flex-wrap:wrap;
`;

      FLAVORS.forEach(flavor => {

        const optionBtn = document.createElement('button');

        optionBtn.type = 'button';
        optionBtn.className = 'flavor-option';
        optionBtn.textContent = flavor.name;

        optionBtn.dataset.flavorName = flavor.name;

        optionBtn.style.cssText = `
    padding:10px 18px;
    border-radius:25px;
    border:1px solid #ddd;
    background:#fff;
    cursor:pointer;
  `;


        optionBtn.addEventListener('click', function () {

          // remove previous selected
          flavorWrapper
            .querySelectorAll('.flavor-option')
            .forEach(btn => {
              btn.classList.remove('active');
              btn.style.background = '#fff';
              btn.style.color = '#000';
            });


          // select current
          this.classList.add('active');
          this.style.background = '#ff7f91';
          this.style.color = '#fff';


          // store selected value
          flavorWrapper.dataset.selectedFlavor = flavor.name;

        });


        flavorWrapper.appendChild(optionBtn);

      });


      label.appendChild(flavorWrapper);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
    wrapper.appendChild(errorMsg);

    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    // protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorOptions = Array.from(
      document.querySelector(BUNDLE_GROUP_SELECTOR).querySelectorAll('.flavor-options')
    );
    const errorMsg = document
      .querySelector(BUNDLE_GROUP_SELECTOR)
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorOptions.some(
      option => !option.dataset.selectedFlavor
    );

    if (flavorOptions.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';

    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorOptions.map(option =>
      option.dataset.selectedFlavor
    );

    // const flavourText =
    //   "Selected Bottle:\n" +
    //   selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

 const flavourText = selectedFlavorNames.join(", ");

let items;
    items = [{
      id: currentProductId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        "Flavour": flavourText
      }
    }];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          drawer.open();

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // ✅ RESET UI (THIS WAS MISSING)

        // reset dropdowns
        document
          .querySelector(BUNDLE_GROUP_SELECTOR)
          .querySelectorAll('.flavor-options')
          .forEach(option => {

            option.dataset.selectedFlavor = '';

            option.querySelectorAll('.flavor-option')
              .forEach(btn => {
                btn.classList.remove('active');
                btn.style.background = '#fff';
                btn.style.color = '#000';
              });

          });

        // hide error
        const errorMsg = document.querySelector('.flavor-error-msg');
        if (errorMsg) {
          errorMsg.style.display = 'none';
          errorMsg.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // Set up the clone once we find the real button
  // ---------------------------------------------------------------------
  function setupButtonSwap(form) {
    if (originalBtn) return; // already done
    const btn = form.querySelector('.add-to-cart');
    if (!btn) return;

    originalBtn = btn;
    customBtn = btn.cloneNode(true);
    customBtn.type = 'submit';
    customBtn.removeAttribute('onclick');
    customBtn.style.display = ''; // ensure it's never left hidden

    customBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      addBundleToCart(form, customBtn);
    });
  }

  // ---------------------------------------------------------------------
  // Swap the button in/out depending on which plan is selected.
  // Visually it's the SAME button (identical clone) — only its wiring differs.
  // Neither button is ever hidden; only one of the two is in the DOM at a time.
  // ---------------------------------------------------------------------
  function syncButtons(form) {
    if (!originalBtn || !customBtn) return;
    const active = isBundleActive(form);

    if (active) {
      if (originalBtn.isConnected) {
        originalBtn.parentNode.replaceChild(customBtn, originalBtn);
      }
    } else {
      if (customBtn.isConnected) {
        customBtn.parentNode.replaceChild(originalBtn, customBtn);
      }
    }
  }

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectFlavorUI(bundleContainer);
    setupButtonSwap(form);
    syncButtons(form);
    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          syncButtons(form);
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);
})();

//  (function () {
//   const FLAVORS = [
//     { name: 'Watermelon Apple & Mint' },
//     { name: 'Coconut Pineapple & Passion Fruit' }
//   ];

//   const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group-id="ccb43adf4b11214494a30251336cfd23e3ad29d0"]';
//   const BUNDLE_SELLING_PLAN_ID = '2784755970';

//   let originalBtn = null; // the theme's real button, with all its original listeners
//   let customBtn = null;   // a clone, stripped of listeners, used only in bundle mode

//   // ---------------------------------------------------------------------
//   // Find the product form dynamically instead of relying on a hardcoded
//   // ID (the theme's auto-generated form ID changes between renders).
//   // We scope the search to the section/container that holds the bundle
//   // widget, and pick the actual add-to-cart form inside it.
//   // ---------------------------------------------------------------------
//   function getForm() {
//     const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
//     if (!bundleContainer) return null;

//     const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
//     return scope.querySelector('form[action*="/cart/add"]');
//   }

//   // ---------------------------------------------------------------------
//   // Is the bundle plan currently selected?
//   // ---------------------------------------------------------------------
//   function isBundleActive(form) {
//     const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
//     if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

//     if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

//     const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
//     if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

//     return false;
//   }

//   // ---------------------------------------------------------------------
//   // Inject flavour dropdowns into the bundle option box
//   // ---------------------------------------------------------------------
//   function injectFlavorUI(bundleContainer) {
//     if (bundleContainer.querySelector('.flavor-select-container')) return;

//     const wrapper = document.createElement('div');
//     wrapper.className = 'flavor-select-container';
//     wrapper.style.marginTop = '10px';
//     wrapper.style.display = 'none';

//     const title = document.createElement('p');
//     title.textContent = 'Choose your flavour:';
//     title.style.margin = '6px 0';
//     wrapper.appendChild(title);

//     for (let i = 1; i <= 1; i++) {
//       const label = document.createElement('label');
//       label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

//       // const labelText = document.createElement('span');
//       // labelText.textContent = 'Bottle ' + i;
//       // label.appendChild(labelText);

//       const flavorWrapper = document.createElement('div');
//       flavorWrapper.className = 'flavor-options';
//       flavorWrapper.dataset.bottleIndex = i;
//       flavorWrapper.style.cssText = `
//   display:flex;
//   gap:10px;
//   flex-wrap:wrap;
// `;

//       FLAVORS.forEach(flavor => {

//         const optionBtn = document.createElement('button');

//         optionBtn.type = 'button';
//         optionBtn.className = 'flavor-option';
//         optionBtn.textContent = flavor.name;

//         optionBtn.dataset.flavorName = flavor.name;

//         optionBtn.style.cssText = `
//     padding:10px 18px;
//     border-radius:25px;
//     border:1px solid #ddd;
//     background:#fff;
//     cursor:pointer;
//   `;


//         optionBtn.addEventListener('click', function () {

//           // remove previous selected
//           flavorWrapper
//             .querySelectorAll('.flavor-option')
//             .forEach(btn => {
//               btn.classList.remove('active');
//               btn.style.background = '#fff';
//               btn.style.color = '#000';
//             });


//           // select current
//           this.classList.add('active');
//           this.style.background = '#ff7f91';
//           this.style.color = '#fff';


//           // store selected value
//           flavorWrapper.dataset.selectedFlavor = flavor.name;

//         });


//         flavorWrapper.appendChild(optionBtn);

//       });


//       label.appendChild(flavorWrapper);
//       wrapper.appendChild(label);
//     }

//     const errorMsg = document.createElement('p');
//     errorMsg.className = 'flavor-error-msg';
//     errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
//     wrapper.appendChild(errorMsg);

//     const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
//     (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

//     // protectFlavorOptions(wrapper);
//   }

//   // ---------------------------------------------------------------------
//   // The theme's own variant/option-picker script disables/hides <option>
//   // elements elsewhere on the page that share the same value/text as the
//   // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
//   // injected dropdown options happen to match that same text, they get
//   // caught by that logic and become unclickable. This observer watches
//   // only our own option elements and immediately undoes any disabled /
//   // hidden / inline-style changes made to them by outside scripts.
//   // ---------------------------------------------------------------------
//   function protectFlavorOptions(wrapper) {
//     const fix = () => {
//       wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
//         if (opt.disabled) opt.disabled = false;
//         if (opt.hidden) opt.hidden = false;
//         if (opt.style.display === 'none') opt.style.display = '';
//       });
//     };

//     fix();

//     const optionObserver = new MutationObserver(fix);
//     optionObserver.observe(wrapper, {
//       subtree: true,
//       attributes: true,
//       attributeFilter: ['disabled', 'hidden', 'style']
//     });
//   }

//   function getErrorMsgEl(form) {
//     return form.querySelector('.flavor-error-msg');
//   }

//   function addBundleToCart(form, btn) {
//     // The flavour dropdowns live in the Seal Subscriptions widget block,
//     // which is OUTSIDE the <form> element — so we must search the whole
//     // document, not just the form, to find them.
//     const flavorOptions = Array.from(
//       document.querySelector(BUNDLE_GROUP_SELECTOR).querySelectorAll('.flavor-options')
//     );
//     const errorMsg = document
//       .querySelector(BUNDLE_GROUP_SELECTOR)
//       .querySelector('.flavor-error-msg');

//     const hasEmptySelection = flavorOptions.some(
//       option => !option.dataset.selectedFlavor
//     );

//     if (flavorOptions.length === 0 || hasEmptySelection) {
//       if (errorMsg) {
//         errorMsg.textContent = 'Please select a flavour for all bottles.';
//         errorMsg.style.display = 'block';
//       } else {
//         alert('Please select a flavour for all bottles.');
//       }
//       return;
//     }
//     if (errorMsg) errorMsg.style.display = 'none';

//     const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
//     const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
//     // Currently selected product variant
//     const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

//     const selectedFlavorNames = flavorOptions.map(option =>
//       option.dataset.selectedFlavor
//     );

//     const flavourText =
//       "Selected Bottles:\n" +
//       selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

//     let items;
//     items = [{
//       id: currentProductId,
//       quantity: 1,
//       selling_plan: sellingPlanId,
//       properties: {
//         flavourText
//       }
//     }];

//     const originalText = btn.textContent;
//     btn.disabled = true;
//     btn.textContent = 'Adding...';

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//       body: JSON.stringify({ items })
//     })
//       .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
//       .then(async () => {
//         const drawer = document.querySelector('.js-cart-drawer');

//         try {
//           const res = await fetch('/cart.js');
//           const cart = await res.json();

//           if (typeof drawer.cartRefreshHandler === 'function') {
//             drawer.cartRefreshHandler(cart);
//           }

//           if (typeof drawer.updateFromCartChange === 'function') {
//             drawer.updateFromCartChange(cart);
//           }

//           drawer.open();

//         } catch (e) {
//           console.error(e);
//           drawer.open();
//         }

//         // ✅ RESET UI (THIS WAS MISSING)

//         // reset dropdowns
//         document
//           .querySelector(BUNDLE_GROUP_SELECTOR)
//           .querySelectorAll('.flavor-options')
//           .forEach(option => {

//             option.dataset.selectedFlavor = '';

//             option.querySelectorAll('.flavor-option')
//               .forEach(btn => {
//                 btn.classList.remove('active');
//                 btn.style.background = '#fff';
//                 btn.style.color = '#000';
//               });

//           });

//         // hide error
//         const errorMsg = document.querySelector('.flavor-error-msg');
//         if (errorMsg) {
//           errorMsg.style.display = 'none';
//           errorMsg.textContent = '';
//         }

//         // reset button
//         btn.disabled = false;
//         btn.textContent = 'Add to cart';
//       })
//       .catch(err => {
//         console.error('Add to cart error:', err);
//         if (errorMsg) {
//           errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
//           errorMsg.style.display = 'block';
//         }
//         btn.disabled = false;
//         btn.textContent = originalText;
//       });
//   }

//   // ---------------------------------------------------------------------
//   // Set up the clone once we find the real button
//   // ---------------------------------------------------------------------
//   function setupButtonSwap(form) {
//     if (originalBtn) return; // already done
//     const btn = form.querySelector('.add-to-cart');
//     if (!btn) return;

//     originalBtn = btn;
//     customBtn = btn.cloneNode(true);
//     customBtn.type = 'submit';
//     customBtn.removeAttribute('onclick');
//     customBtn.style.display = ''; // ensure it's never left hidden

//     customBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       addBundleToCart(form, customBtn);
//     });
//   }

//   // ---------------------------------------------------------------------
//   // Swap the button in/out depending on which plan is selected.
//   // Visually it's the SAME button (identical clone) — only its wiring differs.
//   // Neither button is ever hidden; only one of the two is in the DOM at a time.
//   // ---------------------------------------------------------------------
//   function syncButtons(form) {
//     if (!originalBtn || !customBtn) return;
//     const active = isBundleActive(form);

//     if (active) {
//       if (originalBtn.isConnected) {
//         originalBtn.parentNode.replaceChild(customBtn, originalBtn);
//       }
//     } else {
//       if (customBtn.isConnected) {
//         customBtn.parentNode.replaceChild(originalBtn, customBtn);
//       }
//     }
//   }

//   // ---------------------------------------------------------------------
//   // Show the flavour dropdowns only while the bundle plan is the
//   // selected/checked option; hide them otherwise.
//   // ---------------------------------------------------------------------
//   function updateFlavorVisibility(form) {
//     const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
//     if (!bundleContainer) return;
//     const wrapper = bundleContainer.querySelector('.flavor-select-container');
//     if (!wrapper) return;
//     wrapper.style.display = isBundleActive(form) ? '' : 'none';
//   }

//   // ---------------------------------------------------------------------
//   // Watch the page for the bundle UI appearing / plan switching
//   // ---------------------------------------------------------------------
//   function checkAndInit() {
//     const form = getForm();
//     const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
//     if (!form || !bundleContainer) return;

//     injectFlavorUI(bundleContainer);
//     setupButtonSwap(form);
//     syncButtons(form);
//     updateFlavorVisibility(form);
//   }

//   const observer = new MutationObserver(checkAndInit);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['class', 'aria-checked']
//   });

//   // Run once immediately in case the bundle UI is already in the DOM
//   // at script load time (MutationObserver only fires on future mutations).
//   checkAndInit();

//   document.addEventListener('click', function (e) {
//     if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
//       setTimeout(function () {
//         const form = getForm();
//         if (form) {
//           syncButtons(form);
//           updateFlavorVisibility(form);
//         }
//       }, 50);
//     }
//   }, true);
// })();


// subscribe and save end


// 2 bottle functionality js




(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group="2"]';
  const BUNDLE_SELLING_PLAN_ID = '714600120705';

  // ---------------------------------------------------------------------
  // STATIC compare-at price shown as strikethrough next to bundle price
  // ---------------------------------------------------------------------
  const COMPARE_AT_PRICE = 55.00; // <-- change this value if needed

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive(form) {
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

    if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

    const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
    if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

    return false;
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.marginTop = '10px';
    wrapper.style.display = 'none';

    const title = document.createElement('p');
    title.textContent = 'Choose your flavours:';
    title.style.margin = '6px 0';
    wrapper.appendChild(title);

    for (let i = 1; i <= 2; i++) {
      const label = document.createElement('label');
      label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

      const labelText = document.createElement('span');
      labelText.textContent = 'Bottle ' + i;
      label.appendChild(labelText);

      const select = document.createElement('select');
      select.className = 'flavor-select';
      select.setAttribute('data-bottle-index', i);
      select.style.cssText = 'padding:6px;cursor:pointer;';

      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Select Flavor';
      select.appendChild(defaultOption);

      FLAVORS.forEach(flavor => {
        const option = document.createElement('option');
        option.value = flavor.name;
        option.textContent = flavor.name;
        option.setAttribute('data-flavor-name', flavor.name);
        select.appendChild(option);
      });

      label.appendChild(select);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
    wrapper.appendChild(errorMsg);

    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  // ---------------------------------------------------------------------
  // Compare-at price (strikethrough) + savings badge
  // ---------------------------------------------------------------------
  function injectComparePrice(bundleContainer) {
    const priceContainer = bundleContainer.querySelector('.sls-price-container[data-selling-plan-group="2"]');
    if (!priceContainer) return;

    // avoid duplicate injection on re-renders
    if (priceContainer.querySelector('.compare-at-price')) return;

    const moneyEl = priceContainer.querySelector('.money');
    if (!moneyEl) return;

    // extract numeric value from current price text, e.g. "£49.50 GBP" -> 49.50
    const match = moneyEl.textContent.match(/[\d,]+\.?\d*/);
    if (!match) return;
    const currentPrice = parseFloat(match[0].replace(/,/g, ''));

    const savingsAmount = COMPARE_AT_PRICE - currentPrice;
    if (savingsAmount <= 0) return; // nothing to show if no real saving

    const savingsPercent = Math.round((savingsAmount / COMPARE_AT_PRICE) * 100);

    // Compare-at price (strikethrough), inserted before the current price
    const compareEl = document.createElement('span');
    compareEl.className = 'compare-at-price';
    compareEl.style.cssText = 'text-decoration:line-through;color:#999;font-size:13px;margin-right:6px;';
    compareEl.textContent = `£${COMPARE_AT_PRICE.toFixed(2)}`;

    moneyEl.parentNode.insertBefore(compareEl, moneyEl);

    // Savings badge, appended below the price
    const savingsBadge = document.createElement('div');
    savingsBadge.className = 'savings-badge';
    savingsBadge.style.cssText = 'margin-top:4px;font-size:12px;font-weight:600;color:#1a7f37;';
    savingsBadge.textContent = `save £${savingsAmount.toFixed(2)}`;

    priceContainer.appendChild(savingsBadge);
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorSelects = Array.from(
      document.querySelector(
        '.sls-option-container[data-selling-plan-group="2"]'
      ).querySelectorAll('.flavor-select')
    );
    const errorMsg = document
      .querySelector('.sls-option-container[data-selling-plan-group="2"]')
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorSelects.some(select => select.value === '');

    if (flavorSelects.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';

    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorSelects
      .sort((a, b) => parseInt(a.dataset.bottleIndex, 10) - parseInt(b.dataset.bottleIndex, 10))
      .map(select => select.options[select.selectedIndex].getAttribute('data-flavor-name'));

    const flavourText =
      selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

    let items;
    items = [{
      id: currentProductId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        "Flavour": flavourText
      }
    }];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          drawer.open();

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // reset dropdowns
        document
          .querySelector('.sls-option-container[data-selling-plan-group="2"]')
          .querySelectorAll('.flavor-select')
          .forEach(select => {
            select.value = '';
          });

        // hide error
        const errorMsgAfter = document.querySelector('.flavor-error-msg');
        if (errorMsgAfter) {
          errorMsgAfter.style.display = 'none';
          errorMsgAfter.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectFlavorUI(bundleContainer);
    injectComparePrice(bundleContainer);
    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);

  // ---------------------------------------------------------------------
  // Reliable add-to-cart interception: instead of cloning/swapping the
  // button (which breaks whenever the theme re-renders and replaces the
  // button node), we listen for clicks on ANY current ".add-to-cart"
  // button via event delegation on document, in the capture phase. This
  // keeps working no matter how many times the DOM is re-rendered, and
  // guarantees the flavour dropdown values always reach the cart.
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.add-to-cart');
    if (!btn) return;

    const form = btn.closest('form') || getForm();
    if (!form) return;

    if (isBundleActive(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundleToCart(form, btn);
    }
  }, true);
})();


//reverse js like:

setInterval(() => {
  const combinedRow = document.querySelector(".sls-combined-row");
  const oneTime = document
    .querySelector('input[data-type="one_time"]')
    ?.closest(".sls-option-container");

  if (combinedRow && oneTime && oneTime.nextElementSibling !== combinedRow) {
    oneTime.after(combinedRow);
  }
}, 500);

// 2 bottle functionality end


// 3 bottle functionality start


(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group="1"]';
  const BUNDLE_SELLING_PLAN_ID = '714600022401';

  // ---------------------------------------------------------------------
  // STATIC compare-at price shown as strikethrough next to bundle price
  // ---------------------------------------------------------------------
  const COMPARE_AT_PRICE = 82.50; // <-- change this value if needed

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive(form) {
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

    if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

    const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
    if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

    return false;
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.marginTop = '10px';
    wrapper.style.display = 'none';

    const title = document.createElement('p');
    title.textContent = 'Choose your flavours:';
    title.style.margin = '6px 0';
    wrapper.appendChild(title);

    for (let i = 1; i <= 3; i++) {
      const label = document.createElement('label');
      label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

      const labelText = document.createElement('span');
      labelText.textContent = 'Bottle ' + i;
      label.appendChild(labelText);

      const select = document.createElement('select');
      select.className = 'flavor-select';
      select.setAttribute('data-bottle-index', i);
      select.style.cssText = 'padding:6px;cursor:pointer;';

      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Select Flavor';
      select.appendChild(defaultOption);

      FLAVORS.forEach(flavor => {
        const option = document.createElement('option');
        option.value = flavor.name;
        option.textContent = flavor.name;
        option.setAttribute('data-flavor-name', flavor.name);
        select.appendChild(option);
      });

      label.appendChild(select);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
    wrapper.appendChild(errorMsg);

    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  // ---------------------------------------------------------------------
  // Compare-at price (strikethrough) + savings badge
  // ---------------------------------------------------------------------
  function injectComparePrice(bundleContainer) {
    const priceContainer = bundleContainer.querySelector('.sls-price-container[data-selling-plan-group="1"]');
    if (!priceContainer) return;

    // avoid duplicate injection on re-renders
    if (priceContainer.querySelector('.compare-at-price')) return;

    const moneyEl = priceContainer.querySelector('.money');
    if (!moneyEl) return;

    // extract numeric value from current price text, e.g. "£49.50 GBP" -> 49.50
    const match = moneyEl.textContent.match(/[\d,]+\.?\d*/);
    if (!match) return;
    const currentPrice = parseFloat(match[0].replace(/,/g, ''));

    const savingsAmount = COMPARE_AT_PRICE - currentPrice;
    if (savingsAmount <= 0) return; // nothing to show if no real saving

    const savingsPercent = Math.round((savingsAmount / COMPARE_AT_PRICE) * 100);

    // Compare-at price (strikethrough), inserted before the current price
    const compareEl = document.createElement('span');
    compareEl.className = 'compare-at-price';
    compareEl.style.cssText = 'text-decoration:line-through;color:#999;font-size:13px;margin-right:6px;';
    compareEl.textContent = `£${COMPARE_AT_PRICE.toFixed(2)}`;

    moneyEl.parentNode.insertBefore(compareEl, moneyEl);

    // Savings badge, appended below the price
    const savingsBadge = document.createElement('div');
    savingsBadge.className = 'savings-badge';
    savingsBadge.style.cssText = 'margin-top:4px;font-size:12px;font-weight:600;color:#1a7f37;';
    savingsBadge.textContent = `save £${savingsAmount.toFixed(2)}`;

    priceContainer.appendChild(savingsBadge);
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorSelects = Array.from(
      document.querySelector(
        '.sls-option-container[data-selling-plan-group="1"]'
      ).querySelectorAll('.flavor-select')
    );
    const errorMsg = document
      .querySelector('.sls-option-container[data-selling-plan-group="1"]')
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorSelects.some(select => select.value === '');

    if (flavorSelects.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';

    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorSelects
      .sort((a, b) => parseInt(a.dataset.bottleIndex, 10) - parseInt(b.dataset.bottleIndex, 10))
      .map(select => select.options[select.selectedIndex].getAttribute('data-flavor-name'));

    const flavourText =
      selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

    let items;
    items = [{
      id: currentProductId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        "Flavour": flavourText
      }
    }];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          drawer.open();

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // reset dropdowns
        document
          .querySelector('.sls-option-container[data-selling-plan-group="1"]')
          .querySelectorAll('.flavor-select')
          .forEach(select => {
            select.value = '';
          });

        // hide error
        const errorMsgAfter = document.querySelector('.flavor-error-msg');
        if (errorMsgAfter) {
          errorMsgAfter.style.display = 'none';
          errorMsgAfter.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectFlavorUI(bundleContainer);
    injectComparePrice(bundleContainer);
    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);

  // ---------------------------------------------------------------------
  // Reliable add-to-cart interception: instead of cloning/swapping the
  // button (which breaks whenever the theme re-renders and replaces the
  // button node), we listen for clicks on ANY current ".add-to-cart"
  // button via event delegation on document, in the capture phase. This
  // keeps working no matter how many times the DOM is re-rendered, and
  // guarantees the flavour dropdown values always reach the cart.
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.add-to-cart');
    if (!btn) return;

    const form = btn.closest('form') || getForm();
    if (!form) return;

    if (isBundleActive(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundleToCart(form, btn);
    }
  }, true);
})();

document.querySelectorAll('.small-text').forEach(function(item){
    const subscription = item.querySelector('.subscription-description');
    const property = item.querySelector('.line-item-property');

    if(subscription && property){
        subscription.after(property);
    }
});

// 3 bottle functionality end